/* eslint-disable camelcase */
import React from 'react';
import { Icon } from 'react-icons-kit';
import {
  ic_home,
  ic_account_box,
  ic_list,
  ic_sort,
  ic_keyboard_arrow_down,
} from 'react-icons-kit/md';


const IconHome = () => <Icon icon={ic_home} size={20} />;
const IconUser = () => <Icon icon={ic_account_box} size={20} />;
const IconList = () => <Icon icon={ic_list} size={20} />;
const IconSort = () => <Icon icon={ic_sort} size={20} />;
const IconDown = () => <Icon icon={ic_keyboard_arrow_down} size={20} />;

export {
  IconHome,
  IconUser,
  IconList,
  IconSort,
  IconDown,
};
